import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { Button, Card, Row, Col, Form, Table, Modal, Spinner } from 'react-bootstrap';
import { useFormik } from 'formik';
import Historial from './historial';
import { serviceAddProcesoJudicial, serviceGetGestionImpicado, serviceGetHitosJudiciales, serviceGetProcesosJudiciales } from '../../../../../api/api-antecendentes-legales';
import { dateFormat, getBase64 } from '../../../../../common/Formatos';
import { useRef } from 'react';
import { validationSchemasSeguimientoHito } from '../../../../../common/validation-Shemas-antecedentes-legales';
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../../../../common/uploadArchivoGranTamano';
import { serviceObtieneParametro } from '../../../../../api/api-parametros';
import { LoadingComponent } from 'recupero-comunes';
import Mensajes from '../../../../mensajes'
import { MdBrightness5 } from "react-icons/md";
import ModalApoderadoCIA from './modal-apoderado-cia';

const Seguimiento = ({ cfg_form, proceso, fechaSinistro, setProcesos}) => {
    const fileRef = useRef();
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves } = data_gestion_defensa;
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [hitosJudiciales, setHitosJudiciales] = useState([]);

    const [stateHitoJudicial, setStateHitoJudicial] = useState("");
    const [stateFechaOcurrencia, setStateFechaOcurrencia] = useState("");
    const [stateFechaAudiencia, setStateFechaAudiencia] = useState("");
    const [stateComentario, setStateComentario] = useState("");

    const [codTipoGestion, setCodTipoGestion] = useState(0);
    const [showToast, setShowToast] = useState(false);
    const [responseData, setResponseData] = useState({});
    const [esAudiencia, setEsAudiencia] = useState(false);
    const [showHistorial, setShowHistorial] = useState(false);
    const [handleClickHistorial, setHandleClickHistorial] = useState(false);
    const [codSituacion, setSituacion] = useState(0);

    const [handleDataSubmit, setHandleDataSubmit] = useState(null);
    const [showModalConfirm, setShowModalConfirm] = useState(false);

    const [apoderado, setApoderado] = useState(null);
    const [showModalApoderado, setShowModalApoderado] = useState(false);

    const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
    const [showConfirmGrande, setShowConfirmGrande] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });

    useEffect(() => {
        if (proceso) {
            setApoderado({
                nroTarjetaProf  : proceso.nroTarjetaProf  || 0,
                nombreApoderado : proceso.nombreApoderado  || '',
                emailApoderado  : proceso.emailApoderado   || '',
                paisCelular     : String(proceso.paisCelular || 57),
                celular         : proceso.celular          || ''
            });
            getHitosJudiciales();
        }
    }, [proceso])

    const cargarLimites = async () => {
        const [liviano, pesado] = await Promise.all([serviceObtieneParametro(52), serviceObtieneParametro(53)]);
        setLimites({ liviano, pesado });
    };

    useEffect(() => {
        cargarLimites();
    }, [])

    const getHitosJudiciales = async () => {
        
        let query_one = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: 0 })).toString('base64')
        const response_one = await serviceGetGestionImpicado(query_one);
        let query_two = Buffer.from(JSON.stringify({ tipoGestion: response_one[0].codTipoGestion, idModoIngreso: proceso?.modoIngresoCompetencia })).toString('base64')
        const response_two = await serviceGetHitosJudiciales(query_two);

        setCodTipoGestion(response_one[0].codTipoGestion);
        setHitosJudiciales(response_two);
    }

    const handleHitoJudicial = (value) => {
        setStateHitoJudicial(value);
        let counter = 0;

        setStateFechaAudiencia("");
        formik.setFieldTouched('fechaAudiencia', false, false);

        hitosJudiciales.forEach(hito => { 
            if (hito.id === Number(value) && hito.indAudiencia === 1) counter ++; 
            if (hito.id === Number(value)) { setSituacion(hito.situacion) }
        })
        setEsAudiencia(counter > 0);
    }

    const handleFechaOcurrencia = (value) => {
        setStateFechaOcurrencia(value);
        if (stateFechaAudiencia !== "" && stateFechaAudiencia < value) setStateFechaAudiencia("");
    }

    const handleHistorial = () => {
        setShowHistorial(true);
        setHandleClickHistorial(true);
    }

    const crearHitoJudicial = async (dataSubmit) => {
        setLoading(true);
        setShowModalConfirm(false);
        const response = await serviceAddProcesoJudicial(dataSubmit);

        setLoading(false);
        setResponseData(response);
        setShowToast(true);

        if (response.code === 1) { 
            clearFields(); setLoadData(true); setShowHistorial(true); 

            let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso })).toString('base64');
            const procesos = await serviceGetProcesosJudiciales(query);
            setProcesos(procesos);
        }
    }

    const clearFields = () => {
        formik.resetForm();

        setStateHitoJudicial("");
        setStateFechaOcurrencia("");
        setStateFechaAudiencia("");
        setStateComentario("");
        if (fileRef.current) fileRef.current.value = "";
        setEsAudiencia(false);
        archivoSubidoRef.current = { file: null, s3Bucket: null, s3Key: null };
    }

    const handleFileChange = (e) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        if (esArchivoGrande(file, limites.liviano)) {
            setPendingFile(file);
            setShowConfirmGrande(true);
        } else {
            formik.setFieldValue("file", file);
        }
    }

    const handleCancelArchivoGrande = () => {
        setPendingFile(null);
        if (fileRef.current) fileRef.current.value = "";
        setShowConfirmGrande(false);
    }

    const handleConfirmArchivoGrande = () => {
        formik.setFieldValue("file", pendingFile);
        setShowConfirmGrande(false);
    }

    const enviarHito = async (dataResult, file) => {
        if (file) {
            if (esArchivoGrande(file, limites.liviano)) {
                try {
                    setLoading(true);
                    let archivoRef;
                    if (archivoSubidoRef.current.file === file) {
                        archivoRef = archivoSubidoRef.current;
                    } else {
                        archivoRef = await subirArchivoGrandeS3(file);
                        archivoSubidoRef.current = { file, ...archivoRef };
                    }
                    dataResult = { ...dataResult, "filename": file.name, "mimetype": file.type, "s3Bucket": archivoRef.s3Bucket, "s3Key": archivoRef.s3Key };
                } catch (err) {
                    setLoading(false);
                    setResponseData({ code: -1, object: null, message: err.message });
                    setShowToast(true);
                    return;
                }
            } else {
                const base64data = await getBase64(file);
                dataResult = { ...dataResult, "filename": file.name, "mimetype": file.type, "base64data": base64data.split(',')[1] };
            }
        }
        crearHitoJudicial(dataResult);
    }
    const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
    }
    const handleCloseToast = () => {
        setShowToast(false);
    }
    const formik = useFormik({
        initialValues: {
            codHitoJudicial: "",
            fechaHitoJudicial: "",
            fechaAudiencia: "",
            minutaHitoJudicial: "",
        },
        validationSchema: validationSchemasSeguimientoHito(esAudiencia, limites.pesado),
        onSubmit: async (data) => {

            let dataResult = { ...data };

            dataResult.idCaso = llaves.idCaso;
            dataResult.idOrganizacion = llaves.idOrgCaso;
            dataResult.idUsuario = llaves.idUsuario;
            dataResult.instanciaProceso = proceso.idInstancia;
            dataResult.accion = 3;
            dataResult.estadoProceso = codSituacion == 215005 ? 265002 : 265001;

            dataResult.fechaHitoJudicial = data.fechaHitoJudicial.split('-').join('');
            dataResult.fechaAudiencia = data.fechaAudiencia.split('-').join('');

            if (codSituacion == 215005) {//Situación de cierre: confirmar ANTES de procesar/subir el archivo
                setHandleDataSubmit({ dataResult, file: data.file });
                setShowModalConfirm(true);
            } else {
                await enviarHito(dataResult, data.file);
            }
        }
    })

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <hr style={{ borderTop: '3px solid #04005D' }}></hr>

            <Form onSubmit={formik.handleSubmit}>
                <Card>
                    <Card.Header className="customHeaderCard">
                        {cfg_form["modalantecedentesjudicialesdefensa-subtitle-hitos"]} <span>{`${proceso?.despacho} - Nro. Radicado ${proceso?.rolCausa}`}</span>
                    </Card.Header>

                    <Card.Body>
                        <Row className="mb-3 pb-2" style={{ borderBottom: '1px solid #dee2e6' }}>
                            <Col md='2'>
                                <Form.Label>N° Tarjeta Profesional</Form.Label>
                                <Form.Control disabled value={apoderado?.nroTarjetaProf || ''} />
                            </Col>
                            <Col md='4'>
                                <Form.Label>Apoderado Implicado(s) Tercero</Form.Label>
                                <Form.Control disabled value={apoderado?.nombreApoderado || ''} />
                            </Col>
                            <Col md='3'>
                                <Form.Label>Email</Form.Label>
                                <Form.Control disabled value={apoderado?.emailApoderado || ''} />
                            </Col>
                            <Col md='2'>
                                <Form.Label>Móvil</Form.Label>
                                <Form.Control disabled value={apoderado?.celular ? `+${apoderado.paisCelular} ${apoderado.celular}` : ''} />
                            </Col>
                            <Col md='1' className="d-flex align-items-end">
                                <Button variant='opciones me-md-2' size='sm' onClick={() => setShowModalApoderado(true)}>
                                    <MdBrightness5 size={20} />
                                </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md='8'>
                                <Row>
                                    <Col md='4'>
                                        <Form.Label className="is_required">
                                            {cfg_form["modalantecedentesjudicialesdefensa-cmb-hito"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Select
                                            name='codHitoJudicial'
                                            value={formik.values.codHitoJudicial = stateHitoJudicial}
                                            onChange={(e) => { formik.handleChange(e); handleHitoJudicial(e.target.value) }}>
                                            <option value={''}>Seleccione...</option>
                                            {hitosJudiciales.map((c) => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.codHitoJudicial && formik.touched.codHitoJudicial &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.codHitoJudicial}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='4'>
                                        <Form.Label>
                                            {cfg_form["modalantecedentesjudicialesdefensa-input-fechaocur"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            type="date"
                                            min={dateFormat(fechaSinistro)}
                                            //min={proceso?.fecUltHitoJudicialFormat && dateFormat(proceso?.fecUltHitoJudicialFormat)}
                                            max={hoy()}
                                            //max={proceso.fecUltHitoJudicialFormat && dateFormat(proceso.fecUltHitoJudicialFormat)}
                                            name='fechaHitoJudicial'
                                            value={formik.values.fechaHitoJudicial = stateFechaOcurrencia}
                                            onChange={e => { formik.handleChange(e); handleFechaOcurrencia(e.target.value) }}>
                                        </Form.Control>
                                        {formik.errors.fechaHitoJudicial && formik.touched.fechaHitoJudicial &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.fechaHitoJudicial}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='4'>
                                        <Form.Label>
                                            {cfg_form["modalantecedentesjudicialesdefensa-input-fechaaudi"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            disabled={!esAudiencia}
                                            type="date"
                                            min={stateFechaOcurrencia === "" ? dateFormat(fechaSinistro) : stateFechaOcurrencia}
                                            name='fechaAudiencia'
                                            value={formik.values.fechaAudiencia = stateFechaAudiencia}
                                            onChange={e => { formik.handleChange(e); setStateFechaAudiencia(e.target.value) }}>
                                        </Form.Control>
                                        {formik.errors.fechaAudiencia && formik.touched.fechaAudiencia &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.fechaAudiencia}
                                            </Form.Text>
                                        }
                                    </Col>

                                    <Col md='12' className='mt-2'>
                                        <Form.Label>
                                            {cfg_form["modalantecedentesjudicialesdefensa-intput-comentar"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            as="textarea" rows={3}
                                            name='minutaHitoJudicial'
                                            value={formik.values.minutaHitoJudicial = stateComentario}
                                            onChange={(e) => { formik.handleChange(e); setStateComentario(e.target.value) }}
                                        >
                                        </Form.Control>
                                    </Col>

                                    <Col md='12'>
                                        <Form.Label className='mt-2'>
                                            {cfg_form["modalantecedentesjudicialesdefensa-intputfile-doct"]}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            type="file"
                                            name='file'
                                            ref={fileRef}
                                            onChange={handleFileChange}
                                            onBlur={formik.handleBlur}>
                                        </Form.Control>
                                        {formik.errors.file && formik.touched.file &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.file}
                                            </Form.Text>
                                        }
                                    </Col>

                                </Row>
                            </Col>

                            <Col md='4'>
                                <h5 style={{ color: '#3a3a8d' }}>Implicado(s)</h5>

                                <div className="customResponsive">
                                    <Table striped>
                                        <tbody>
                                            {proceso?.implicados.map((implicado, index) => (
                                                <tr key={index}>
                                                    <td>{implicado.idImplicado}</td>
                                                    <td>{implicado.nombreImplicado}</td>
                                                    <td>{implicado.patenteImplicado}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    {proceso?.implicados.length === 0 &&
                                        <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                    {showToast && 
                        <Mensajes
                            showToast={showToast}
                            handleCloseToast={handleCloseToast}
                            delay={5000}
                            responseData={responseData}
                        ></Mensajes>
                    }

                    <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                        <Button className='w-auto' variant='info' style={{ color: 'white' }} onClick={handleHistorial}>
                            {cfg_form["modalantecedentesjudicialesdefensa-btn-historial"]}
                        </Button>
                        <Button type="submit" disabled={proceso?.estado != 265001 || loading} className='w-auto' variant='danger'>
                            {loading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                            {cfg_form["modalantecedentesjudicialesdefensa-btn-actualizar"]}
                        </Button>
                    </Card.Footer>
                </Card>
            </Form>
            <Modal show={showModalConfirm} onHide={() => setShowModalConfirm(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>

                    <Card.Body>
                        Dado la selección de hito de término. ¿Confirma cierre de proceso judicial?
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalConfirm(false)}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={() => { setShowModalConfirm(false); enviarHito(handleDataSubmit.dataResult, handleDataSubmit.file); }}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>

                    <Card.Body>
                        {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                    </Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            {showHistorial && <Historial
                codTipoGestion={codTipoGestion}
                proceso={proceso}
                loadData={loadData}
                setLoadData={setLoadData}
                showHistorial={showHistorial}
                handleClickHistorial={handleClickHistorial}
                setHandleClickHistorial={setHandleClickHistorial}
            />}

            <ModalApoderadoCIA
                show={showModalApoderado}
                onHide={() => setShowModalApoderado(false)}
                apoderadoInicial={apoderado}
                idInstancia={proceso?.idInstancia}
                idCaso={llaves.idCaso}
                idUsuario={llaves.idUsuario}
                onRegistrar={(datos) => setApoderado(datos)}
            />

            <style type='text/css'>
                {`
                    .customHeaderCard {
                        background-color: rgb(176 175 196);
                        color: #3a3a8d;
                        font-size: 17px;
                        font-weight: 600
                    }
                    .customHeaderCard span{
                        background-color: rgb(176 175 196);
                        color: #6363d7;
                        font-size: 15px;
                        font-weight: 600
                    }
                    .is_required:after {
                        content: "(*)";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .customResponsive {
                        overflow-x: auto;
                        height: 240px !important;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Seguimiento;